import { r as registerInstance, h, g as getElement } from './index-5faac9d7.js';

const notificationCss = ".notification{display:flex;padding:16px;font-size:12px;line-height:18px;color:#333333}@media screen and (min-width: 980px){.notification{padding:18px}}:host(:not([dir=\"rtl\"])) .notification__icon{margin-right:16px}:host([dir=\"rtl\"]) .notification__icon{margin-left:16px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .notification__icon{margin-right:18px}:host([dir=\"rtl\"]) .notification__icon{margin-left:18px}}.notification__text{flex:1 0 0px}.alert{background-color:rgba(228, 127, 0, 0.1)}.alert .notification__icon{color:#e47f00}";

const Notification = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
    this.icon = undefined;
    this.colorScheme = 'alert';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: `notification ${this.colorScheme}` }, this.icon ? (h("div", { class: "notification__icon" }, h("pes-icon", null, this.icon))) : null, this.label ? h("div", { class: "notification__text" }, this.label) : null));
  }
  get el() { return getElement(this); }
};
Notification.style = notificationCss;

export { Notification as pes_notification };
